export const MOCK_APPLICATION = {
  applicationId: 'a1b3f423-0eed-4690-8983-306b8493527a',
  applicationStatus: 'complete',
  metaData: {
    acceptedQuote: {
      id: '57161e14-cf23-4f5f-ae05-9583cabb5078',
      erpQuoteRef: '576938',
    },
    quoteId: '57161e14-cf23-4f5f-ae05-9583cabb5078',
    creditCheckId: 'e879628d-7bb8-4c7f-aaf8-8f08861f4499',
    creditCheckCompleted: true,
    quotes: ['57161e14-cf23-4f5f-ae05-9583cabb5078'],
    customerOptions: {
      optionalEquipment: [],
      kmsPerYear: 10000,
      annualSalary: 90000,
      businessUse: 0,
      vehicleCondition: 'new',
      carValue: 50000,
      leaseTerm: 48,
      variant: '103339',
      adhocEquipment: [],
      bodyType: 'Small',
    },
    hrApprovalRequestSent: true,
  },
};

export const MOCK_USER = {
  profile: {
    companyName: 'Eclipx',
    companyEmail: 'sophie.segouin@eclipx.com',
    postcode: '2200',
    contactNumber: '0406645313',
    noCorporateEmail: true,
    corporateEmailVerified: true,
    matchesOrganisations: 'multiple',
    firstName: 'Sophie',
  },
  hasOrganisation: true,
  entity: 'fleetPartners',
  permissions: ['SAIGON:HR:APPROVAL', 'SAIGON:HR:APPROVAL'],
  features: {
    greenId: true,
    payslipValidation: true,
    useCatcheDataSource: false,
    defaultFundSource: false,
    multiQuotes: true,
    settlement: true,
    gbgIdScan: true,
    inLife: true,
    docuSign: true,
  },
  accessLevel: 'APPLICATION',
};

export const MOCK_QUOTE = {
  quoteId: '023f2b84-5e6e-439c-ad3e-d0e2b3ad9b3a',
  erpQuoteRef: '1576413',
  milesQuoteRef: '000674',
  status: 'ACCEPTED',
  make: {
    description: 'TOYOTA',
  },
  bodyType: 'SUV',
  model: {
    name: 'LANDCRUISER 70',
  },
  variant: {
    name: 'TOYOTA LANDCRUISER 70 GDJL76R GXL 2.8 5DR S/CAB SUV 4WD 6SPD AUT DIESEL 5SEATS',
    gears: '1',
    doors: '5DR',
    modelYear: '2024',
    fuelTankCapacity: '2755.00',
    transmission: 'AUT6',
    photos: [
      {
        path: 'https://assets.fleetpartners.com.au/vehicle_images_au/TOYOTA/LANDCRUISER 70/2024/5OC-4.JPG',
      },
      {
        path: 'https://assets.fleetpartners.com.au/vehicle_images_au/TOYOTA/LANDCRUISER 70/2024/5OC-4-4-C.JPG',
      },
      {
        path: 'https://assets.fleetpartners.com.au/vehicle_images_au/TOYOTA/LANDCRUISER 70/2024/5OC-4-4-C GXL.JPG',
      },
    ],
  },
  leaseTerm: 48,
  kmsPerYear: 30000,
  novated: {
    impactTakeHome: 2590.69,
  },
  exteriorColour: {
    name: 'Graphite',
  },
};

export const MOCK_SETTLEMENT = {
  orderId: '150387',
  status: 'carReady',
  approximateDelivery: '2022-01-24T00:00:00.000Z',
  confirmedDelivery: '2022-01-24T00:00:00.000Z',
  dealer: {
    name: 'Action Ford',
    location: 'GPO Box 386 GYMPIE, QLD, 4570',
  },
  hasDocusign: true,
  deliveryMessage: '',
};

export const MOCK_ACTIONS = {
  // Action called when the button to load docusign is clicked
  onCallDocusign() {
    // eslint-disable-next-line
    console.log('Call Docusign');
  },
};

export default {
  mountSelector: '#app',
  user: MOCK_USER,
  application: MOCK_APPLICATION,
  settlement: MOCK_SETTLEMENT,
  quote: MOCK_QUOTE,
  actions: MOCK_ACTIONS,
};
